import styles from '../styles/CreatorAnalytics.module.scss';
import { IoIosTrendingUp } from "react-icons/io";

interface StatCardProps {
  label: string;
  value: string;
  change: string;
  changePct: string;
  icon: React.ReactNode;
  iconClass: string;
}


const AnalyticsStatCard: React.FC<StatCardProps> = ({ label, value, change, changePct, icon, iconClass }) => (
  <div className={styles.statCard}>
    <div className={styles.statTop}>
      <div>
        <p className={styles.statLabel}>{label}</p>
        <p className={styles.statValue}>{value}</p>
      </div>
      <div className={`${styles.statIcon} ${styles[iconClass]}`}>{icon}</div>
    </div>
    <div className={styles.statBottom}>
      <span className={styles.statChange}><IoIosTrendingUp size={16} /> {changePct}</span>
      <span className={styles.statVs}>vs previous period</span>
    </div>
  </div>
);

export default AnalyticsStatCard;